export const questionsAndAnswers = [
    {
        "id": 1,
        "Q": "Can customers see their exact slab?",
        "A": `\u2022    Yes, the process is dependent on the assigned fabricator and their process.
\u2022    Granite is a naturally occurring resource, and the pattern and veining will vary from slab to slab.Each granite slab is unique.Customers complete the slab viewing process prior to install.
\u2022    Quartz is a man made material and is identical from slab to slab.It is not necessary for customers to view quartz slabs prior to install.`
    },
    {   "id": 2,
        "Q": "Can customers view the fabricator's showroom for any allen+roth colors?",
        "A": "\u2022    Fabricators will not have all colors available, as they order material by project. Please check with your local fabricator for their current availability of slabs to view."
    },
    {
        "id": 3,
        "Q": "Can we also sell quartz colors/other granite colors under our regional program?",
        "A": "\u2022    Check with the local fabricator for out of program colors that are available."
    },
    {
        "id": 4,
        "Q": "Where can we get the small samples of quartz and granite from for customer to take?",
        "A": `\u2022    Purchase online through Lowe's or <a target='_blank' href='http://www.sagesurfaces.com'>Sage Surfaces</a>
\u2022    Please advise customers that these samples are a representation of countertop.
\u2022    We encourage customers to purchase samples to view the countertop sample under the light in their kitchen and against the colors and materials they are using in their renovation.`
    },
    {
        "id": 5,
        "Q": "Where on the portal can they order allen+roth literature?",
        "A": "\u2022    Refer to the reorder literature document in the Metis document library."
    },
    {
        "id": 6,
        "Q": "What is the sq. ft. minimum for wood tops?",
        "A": `\u2022    The minimum is 20 sq. ft.
\u2022    Less sq. ft. is available for purchase if the customer pays the freight charge of $350.`
    },
    {
        "id": 7,
        "Q": "Can the customer provide their own sink?",
        "A": "\u2022    Customers can either purchase a sink from our programs, Lowe's, or provide their own."
    },
    {
        "id": 8,
        "Q": "Who does the customer call about their change order?",
        "A": "\u2022    Sage Support Specialists manage change orders."
    },
    {
        "id": 9,
        "Q": "Can the customer keep their current splash?",
        "A": "\u2022    Refer to the backsplash pages. Typically, customers cannot keep their backsplash."
    },
    {
        "id": 10,
        "Q": "Can the customer choose seam placement?",
        "A": "\u2022    Yes, however this may affect sq ft of project which will increase the price. Please refer to the seam's pages."
    },
    {
        "id": 11,
        "Q": "Can the customer choose what part of the slab to use and where?",
        "A": "\u2022    Yes, however this may affect sq ft of project which will increase the price. Some fabricators use a tool called slab smith to show the layout of vein and seams."
    },
    {
        "id": 12,
        "Q": "What kind of warranty does the customer receive?",
        "A": "\u2022    Refer to warranty information located on the product's resource guide in the Resource Guide tab or on the Sage website at <a target='_blank' href='http://www.sagesurfaces.com'>Sage Surfaces</a>"
    },
    {
        "id": 13,
        "Q": "How long does the entire process take?",
        "A": `\u2022    Depends on volume/ availability of material. Contracted lead times is 14 business days post template from the final project approval, post template.
\u2022    Always contact your local fabricator for the most up to date lead times.`
    },
    {
        "id": 14,
        "Q": "Where can I find the fabricator's contact for a product?",
        "A": "\u2022    Assigned Providers Tab"
    },
    {
        "id": 15,
        "Q": "Where can I create an estimate or quote?",
        "A": `\u2022    Estimator tab! Do you need a training guide? Go to Document Library and search "Estimator" for a training video.`
    },
    {
        "id": 16,
        "Q": "How do I sell Small Projects?",
        "A": "\u2022    Go to the Resource Guide tab and review the steps in the Small Projects Program online resource guide."
    },
    {
        "id": 17,
        "Q": "What is the cancellation policy?",
        "A": `\u2022    Contract your allen + roth CFI immediately for all returns / cancellations.
\u2022    Countertop cancellation prior to template date - Full Refund is Approved.
\u2022    Template completed and then customer cancels order - PO for measure detail is required.
\u2022    Fabrication complete customer cancels order, but top not installed - PO for 75% of the value of total or final PO(s) is due.
\u2022    No refunds on installed goods`
    },
    {
        "id": 18,
        "Q": "How do I order more brochures or design guides?",
        "A": "\u2022    Go to the Document Library tab and search for CART Brochure Reorder Number Sheet"
    },
    {
        "id": 19,
        "Q": "How do I order replacement display samples?",
        "A": "\u2022    Go to the Document Library tab and search for Planogram. On the planograms, locate the reorder number of the sample needed and place the order in Spend Management."
    },
    {
        "id": 20,
        "Q": "How do I order replacement labels?",
        "A": "\u2022    Go to the Document Library tab and search for Wallboard Sample Label Reorder Number List. Locate the reorder number of the label needed and place the order in Spend Management."
    }
    

]